export const plans = [
  { title: 'Initial consultation meeting', amount: '$ 500' },
  { title: 'Procedure and medical support', amount: '$ 7,000' },
  { title: 'Medications', amount: '$ 5,000' },
  { title: 'Annual storage', amount: '$ 500' },
];
